/**
 * Hostname-specific Page Titles (H1)
 * 
 * This file provides unique H1 titles for each page of each domain,
 * ensuring Google indexes each domain separately without duplicate content penalties.
 * 
 * Each hostname gets unique H1 titles for: home, solutions, products, blog, resources, 
 * request-demo, privacy, contact, compare-prices
 */

export const HOSTNAME_PAGE_TITLES = {
  // ============================================
  // Geotab Camera Domains
  // ============================================
  'geotabcamera.com': {
    home: 'Geotab Camera - Fleet Video Telematics',
    solutions: 'Geotab Camera Fleet Solutions',
    products: 'Geotab Camera Products',
    blog: 'Geotab Camera Blog',
    resources: 'Geotab Camera Resource Center',
    'request-demo': 'Request a Geotab Camera Demo',
    privacy: 'Geotab Camera Privacy Policy',
    contact: 'Contact Geotab Camera',
  },
  'geotab.cam': {
    home: 'Geotab Cam - Video Solutions for Fleets',
    solutions: 'Geotab Cam Fleet Video Solutions',
    products: 'Geotab Cam Products & Equipment',
    blog: 'Geotab Cam News & Insights',
    resources: 'Geotab Cam Resources',
    'request-demo': 'Get a Geotab Cam Demo',
    privacy: 'Geotab Cam Privacy Policy',
    contact: 'Contact Geotab Cam',
  },

  // ============================================
  // Geotab Dashcam Domains
  // ============================================
  'geotabdashcams.com': {
    home: 'Geotab Dashcams - Professional Fleet Dash Cameras',
    solutions: 'Geotab Dashcams Solutions',
    products: 'Geotab Dashcams Products',
    blog: 'Geotab Dashcams Blog',
    resources: 'Geotab Dashcams Resource Center',
    'request-demo': 'Request a Geotab Dashcams Demo',
    privacy: 'Geotab Dashcams Privacy Policy',
    contact: 'Contact Geotab Dashcams',
  },
  'geotabdashcam.com': {
    home: 'Geotab Dashcam - Commercial Dash Camera Solutions',
    solutions: 'Geotab Dashcam Fleet Solutions',
    products: 'Geotab Dashcam Products',
    blog: 'Geotab Dashcam Insights',
    resources: 'Geotab Dashcam Resources',
    'request-demo': 'Get a Geotab Dashcam Demo',
    privacy: 'Geotab Dashcam Privacy Policy',
    contact: 'Contact Geotab Dashcam',
  },

  // ============================================
  // Geotab Go Focus Plus
  // ============================================
  'geotabgofocusplus.com': {
    home: 'Geotab GO Focus Plus Camera',
    solutions: 'GO Focus Plus Fleet Solutions',
    products: 'GO Focus Plus Products',
    blog: 'GO Focus Plus Blog',
    resources: 'GO Focus Plus Resource Center',
    'request-demo': 'Request a GO Focus Plus Demo',
    privacy: 'GO Focus Plus Privacy Policy',
    contact: 'Contact GO Focus Plus',
  },

  // ============================================
  // Geotab Equipment
  // ============================================
  'geotabequipment.com': {
    home: 'Geotab Equipment - Fleet Management Hardware',
    solutions: 'Geotab Equipment Solutions',
    products: 'Geotab Equipment Products',
    blog: 'Geotab Equipment Blog',
    resources: 'Geotab Equipment Resource Center',
    'request-demo': 'Request a Geotab Equipment Demo',
    privacy: 'Geotab Equipment Privacy Policy',
    contact: 'Contact Geotab Equipment',
  },

  // ============================================
  // Geotab Partner Domains
  // ============================================
  'geotabpartner.com': {
    home: 'Geotab Partner - Authorized Geotab Reseller',
    solutions: 'Geotab Partner Solutions',
    products: 'Geotab Partner Products',
    blog: 'Geotab Partner Blog',
    resources: 'Geotab Partner Resource Center',
    'request-demo': 'Become a Geotab Partner',
    privacy: 'Geotab Partner Privacy Policy',
    contact: 'Contact Geotab Partner',
  },
  'geotab.ai': {
    home: 'Geotab AI - AI-Powered Fleet Intelligence',
    solutions: 'Geotab AI Fleet Solutions',
    products: 'Geotab AI Products',
    blog: 'Geotab AI Insights',
    resources: 'Geotab AI Resource Center',
    'request-demo': 'Request a Geotab AI Demo',
    privacy: 'Geotab AI Privacy Policy',
    contact: 'Contact Geotab AI',
  },

  // ============================================
  // GoGeotab Domains
  // ============================================
  'gogeotab.com': {
    home: 'GoGeotab - Geotab Fleet Tracking Solutions',
    solutions: 'GoGeotab Fleet Solutions',
    products: 'GoGeotab Products',
    blog: 'GoGeotab Blog',
    resources: 'GoGeotab Resource Center',
    'request-demo': 'Request a GoGeotab Demo',
    privacy: 'GoGeotab Privacy Policy',
    contact: 'Contact GoGeotab',
  },
  'geotabgo.com': {
    home: 'Geotab GO - Start Your Fleet Management Journey',
    solutions: 'Geotab GO Solutions',
    products: 'Geotab GO Products',
    blog: 'Geotab GO Blog',
    resources: 'Geotab GO Resources',
    'request-demo': 'Get Started with Geotab GO',
    privacy: 'Geotab GO Privacy Policy',
    contact: 'Contact Geotab GO',
  },

  // ============================================
  // Geotab Store Domains
  // ============================================
  'geotabstore.com': {
    home: 'Geotab Store - Official Geotab Equipment Shop',
    solutions: 'Geotab Store Solutions',
    products: 'Shop Geotab Products',
    blog: 'Geotab Store Blog',
    resources: 'Geotab Store Resource Center',
    'request-demo': 'Request a Quote from Geotab Store',
    privacy: 'Geotab Store Privacy Policy',
    contact: 'Contact Geotab Store',
  },
  'geotab.store': {
    home: 'Geotab.Store - Shop Geotab Devices Online',
    solutions: 'Geotab.Store Solutions',
    products: 'Browse Geotab.Store Products',
    blog: 'Geotab.Store News',
    resources: 'Geotab.Store Resources',
    'request-demo': 'Get a Quote from Geotab.Store',
    privacy: 'Geotab.Store Privacy Policy',
    contact: 'Contact Geotab.Store',
  },
  'shopgeotab.com': {
    home: 'Shop Geotab - Your Geotab Equipment Destination',
    solutions: 'Shop Geotab Solutions',
    products: 'Shop Geotab Products',
    blog: 'Shop Geotab Blog',
    resources: 'Shop Geotab Resources',
    'request-demo': 'Request a Shop Geotab Quote',
    privacy: 'Shop Geotab Privacy Policy',
    contact: 'Contact Shop Geotab',
  },

  // ============================================
  // Fleet Keyless Domains
  // ============================================
  'fleetkeyless.com': {
    home: 'Fleet Keyless - Keyless Vehicle Access Solutions',
    solutions: 'Fleet Keyless Solutions',
    products: 'Fleet Keyless Products',
    blog: 'Fleet Keyless Blog',
    resources: 'Fleet Keyless Resource Center',
    'request-demo': 'Request a Fleet Keyless Demo',
    privacy: 'Fleet Keyless Privacy Policy',
    contact: 'Contact Fleet Keyless',
  },
  'geotabkey.com': {
    home: 'Geotab Key - Smart Keyless Fleet Access',
    solutions: 'Geotab Key Solutions',
    products: 'Geotab Key Products',
    blog: 'Geotab Key Blog',
    resources: 'Geotab Key Resource Center',
    'request-demo': 'Request a Geotab Key Demo',
    privacy: 'Geotab Key Privacy Policy',
    contact: 'Contact Geotab Key',
  },
  'geotabkeyless.com': {
    home: 'Geotab Keyless - Advanced Fleet Key Management',
    solutions: 'Geotab Keyless Solutions',
    products: 'Geotab Keyless Products',
    blog: 'Geotab Keyless Blog',
    resources: 'Geotab Keyless Resources',
    'request-demo': 'Request a Geotab Keyless Demo',
    privacy: 'Geotab Keyless Privacy Policy',
    contact: 'Contact Geotab Keyless',
  },
  'keylessfleet.com': {
    home: 'Keyless Fleet - Modern Fleet Access Control',
    solutions: 'Keyless Fleet Solutions',
    products: 'Keyless Fleet Products',
    blog: 'Keyless Fleet Blog',
    resources: 'Keyless Fleet Resources',
    'request-demo': 'Request a Keyless Fleet Demo',
    privacy: 'Keyless Fleet Privacy Policy',
    contact: 'Contact Keyless Fleet',
  },
  'myfleetkey.com': {
    home: 'My Fleet Key - Your Smart Fleet Access Solution',
    solutions: 'My Fleet Key Solutions',
    products: 'My Fleet Key Products',
    blog: 'My Fleet Key Blog',
    resources: 'My Fleet Key Resources',
    'request-demo': 'Get Your Fleet Key Demo',
    privacy: 'My Fleet Key Privacy Policy',
    contact: 'Contact My Fleet Key',
  },

  // ============================================
  // Road Eazy Domains
  // ============================================
  'roadeazy.cam': {
    home: 'RoadEazy - AI Dash Cam & Fleet Camera Systems',
    solutions: 'RoadEazy Fleet Camera Solutions',
    products: 'RoadEazy Dash Cam Products',
    blog: 'RoadEazy Blog',
    resources: 'RoadEazy Resource Center',
    'request-demo': 'Request a RoadEazy Demo',
    privacy: 'RoadEazy Privacy Policy',
    contact: 'Contact RoadEazy',
  },
  'shoproadeazy.com': {
    home: 'Shop RoadEazy - Buy AI Dash Cams Online',
    solutions: 'Shop RoadEazy Camera Solutions',
    products: 'Shop RoadEazy Products',
    blog: 'Shop RoadEazy News',
    resources: 'Shop RoadEazy Buying Guide',
    'request-demo': 'Get a RoadEazy Quote',
    privacy: 'Shop RoadEazy Privacy Policy',
    contact: 'Contact Shop RoadEazy',
  },
  'buyroadeazy.com': {
    home: 'Buy RoadEazy - AI Fleet Cameras',
    solutions: 'RoadEazy Commercial Fleet Solutions',
    products: 'Buy RoadEazy Products',
    blog: 'Buy RoadEazy Blog',
    resources: 'RoadEazy Buying Resources',
    'request-demo': 'Order RoadEazy Today',
    privacy: 'Buy RoadEazy Privacy Policy',
    contact: 'Contact Buy RoadEazy',
  },
  'roadeazycamera.com': {
    home: 'RoadEazy Advanced Dash Cam Solution',
    solutions: 'RoadEazy All-In-One Platform',
    products: 'RoadEazy Camera Products',
    blog: 'RoadEazy Camera Insights',
    resources: 'RoadEazy Camera Resources',
    'request-demo': 'Request a RoadEazy Camera Demo',
    privacy: 'RoadEazy Camera Privacy Policy',
    contact: 'Contact RoadEazy Camera',
  },

  // ============================================
  // Lytx Camera Domain
  // ============================================
  'lytx.camera': {
    home: 'Lytx Camera - Professional Fleet Video Solutions',
    solutions: 'Lytx Camera Fleet Solutions',
    products: 'Lytx Camera Products',
    blog: 'Lytx Camera Blog',
    resources: 'Lytx Camera Resource Center',
    'request-demo': 'Request a Lytx Camera Demo',
    privacy: 'Lytx Camera Privacy Policy',
    contact: 'Contact Lytx Camera',
  },

  // ============================================
  // Surfsight Camera Domains
  // ============================================
  'surfsight.cam': {
    home: 'Surfsight Cam - AI-Powered Fleet Dash Camera',
    solutions: 'Surfsight Cam Fleet Solutions',
    products: 'Surfsight Cam Products',
    blog: 'Surfsight Cam Blog',
    resources: 'Surfsight Cam Resource Center',
    'request-demo': 'Request a Surfsight Cam Demo',
    privacy: 'Surfsight Cam Privacy Policy',
    contact: 'Contact Surfsight Cam',
  },
  'surfsight.camera': {
    home: 'Surfsight Camera - Professional Fleet Video Solutions',
    solutions: 'Surfsight Camera Solutions',
    products: 'Surfsight Camera Products',
    blog: 'Surfsight Camera Blog',
    resources: 'Surfsight Camera Resources',
    'request-demo': 'Request a Surfsight Camera Demo',
    privacy: 'Surfsight Camera Privacy Policy',
    contact: 'Contact Surfsight Camera',
  },

  // ============================================
  // Lytx Store Domains
  // ============================================
  'lytxstore.com': {
    home: 'Lytx Store - Official Lytx Equipment Shop',
    solutions: 'Lytx Store Solutions',
    products: 'Shop Lytx Products',
    blog: 'Lytx Store Blog',
    resources: 'Lytx Store Resource Center',
    'request-demo': 'Request a Lytx Store Quote',
    privacy: 'Lytx Store Privacy Policy',
    contact: 'Contact Lytx Store',
  },
  'shoplytx.com': {
    home: 'Shop Lytx - Buy DriveCam & Fleet Cameras',
    solutions: 'Shop Lytx Solutions',
    products: 'Shop Lytx Products',
    blog: 'Shop Lytx News',
    resources: 'Shop Lytx Resources',
    'request-demo': 'Get a Shop Lytx Quote',
    privacy: 'Shop Lytx Privacy Policy',
    contact: 'Contact Shop Lytx',
  },

  // ============================================
  // Shop Surfsight Domains
  // ============================================
  'shopsurfsight.com': {
    home: 'Shop Surfsight - Buy Surfsight Cameras & Accessories',
    solutions: 'Shop Surfsight Solutions',
    products: 'Shop Surfsight Products',
    blog: 'Shop Surfsight Blog',
    resources: 'Shop Surfsight Resources',
    'request-demo': 'Request a Surfsight Quote',
    privacy: 'Shop Surfsight Privacy Policy',
    contact: 'Contact Shop Surfsight',
  },
  'surfsight.shop': {
    home: 'Surfsight Shop - Your Fleet Camera Store',
    solutions: 'Surfsight Shop Solutions',
    products: 'Surfsight Shop Products',
    blog: 'Surfsight Shop News',
    resources: 'Surfsight Shop Resources',
    'request-demo': 'Get a Surfsight Shop Quote',
    privacy: 'Surfsight Shop Privacy Policy',
    contact: 'Contact Surfsight Shop',
  },
  'surfsightstore.com': {
    home: 'Surfsight Store - Authorized Surfsight Dealer',
    solutions: 'Surfsight Store Solutions',
    products: 'Surfsight Store Products',
    blog: 'Surfsight Store Blog',
    resources: 'Surfsight Store Resources',
    'request-demo': 'Request a Surfsight Store Quote',
    privacy: 'Surfsight Store Privacy Policy',
    contact: 'Contact Surfsight Store',
  },

  // ============================================
  // Fleet Hours of Service / ELD Domains
  // ============================================
  'fleethoursofservice.com': {
    home: 'Fleet Hours of Service - ELD Compliance Made Simple',
    solutions: 'Fleet Hours of Service Solutions',
    products: 'Fleet Hours of Service Products',
    blog: 'Fleet Hours of Service Blog',
    resources: 'Fleet Hours of Service Resource Center',
    'request-demo': 'Request an ELD Compliance Demo',
    privacy: 'Fleet Hours of Service Privacy Policy',
    contact: 'Contact Fleet Hours of Service',
  },
  'eldsystem.com': {
    home: 'ELD System - Electronic Logging Device Solutions',
    solutions: 'ELD System Compliance Solutions',
    products: 'ELD System Products',
    blog: 'ELD System Blog',
    resources: 'ELD System Resource Center',
    'request-demo': 'Request an ELD System Demo',
    privacy: 'ELD System Privacy Policy',
    contact: 'Contact ELD System',
  },
  'eldtracker.com': {
    home: 'ELD Tracker - Fleet ELD Tracking Solutions',
    solutions: 'ELD Tracker Solutions',
    products: 'ELD Tracker Products',
    blog: 'ELD Tracker Blog',
    resources: 'ELD Tracker Resource Center',
    'request-demo': 'Request an ELD Tracker Demo',
    privacy: 'ELD Tracker Privacy Policy',
    contact: 'Contact ELD Tracker',
  },

  // ============================================
  // Fleet Dashcam Domain
  // ============================================
  'fleetdashcam.com': {
    home: 'Professional Fleet Dash Cameras',
    solutions: 'Fleet Dashcam Solutions',
    products: 'Fleet Dash Cameras',
    blog: 'Fleet Dashcam Blog',
    resources: 'Fleet Dashcam Resource Center',
    'request-demo': 'Request a Fleet Dashcam Demo',
    privacy: 'Fleet Dashcam Privacy Policy',
    contact: 'Contact Fleet Dashcam',
  },

  // ============================================
  // Fleet Flix Domain
  // ============================================
  'fleetflix.com': {
    home: 'Fleet Flix - Fleet Video Streaming Solutions',
    solutions: 'Fleet Flix Video Solutions',
    products: 'Fleet Flix Products',
    blog: 'Fleet Flix Blog',
    resources: 'Fleet Flix Resource Center',
    'request-demo': 'Request a Fleet Flix Demo',
    privacy: 'Fleet Flix Privacy Policy',
    contact: 'Contact Fleet Flix',
  },

  // ============================================
  // Other Domains
  // ============================================
  'smartertracking.com': {
    home: 'Smarter Tracking - Intelligent Fleet Management',
    solutions: 'Smarter Tracking Solutions',
    products: 'Smarter Tracking Products',
    blog: 'Smarter Tracking Blog',
    resources: 'Smarter Tracking Resource Center',
    'request-demo': 'Request a Smarter Tracking Demo',
    privacy: 'Smarter Tracking Privacy Policy',
    contact: 'Contact Smarter Tracking',
  },
  'goinsights.com': {
    home: 'Go Insights - Fleet Analytics & Intelligence',
    solutions: 'Go Insights Analytics Solutions',
    products: 'Go Insights Products',
    blog: 'Go Insights Blog',
    resources: 'Go Insights Resource Center',
    'request-demo': 'Request a Go Insights Demo',
    privacy: 'Go Insights Privacy Policy',
    contact: 'Contact Go Insights',
  },
};

/**
 * Get H1 title for a specific hostname and page
 * @param {string} hostname - The hostname (e.g., 'roadeazy.cam')
 * @param {string} pageName - The page name (e.g., 'home', 'solutions')
 * @returns {string|null} - H1 title or null if not found
 */
export const getPageTitle = (hostname, pageName) => {
  const cleanHostname = hostname?.replace(/^www\./, '').toLowerCase();
  const hostTitles = HOSTNAME_PAGE_TITLES[cleanHostname];
  
  if (hostTitles && hostTitles[pageName]) {
    return hostTitles[pageName];
  }
  
  return null;
};

/**
 * Get all page titles for a specific hostname
 * @param {string} hostname - The hostname
 * @returns {object|null} - Object with all page titles or null
 */
export const getAllPageTitles = (hostname) => {
  const cleanHostname = hostname?.replace(/^www\./, '').toLowerCase();
  return HOSTNAME_PAGE_TITLES[cleanHostname] || null;
};

/**
 * Check if a hostname has custom page titles configured
 * @param {string} hostname 
 * @returns {boolean}
 */
export const hasCustomPageTitles = (hostname) => {
  const cleanHostname = hostname?.replace(/^www\./, '').toLowerCase();
  return cleanHostname in HOSTNAME_PAGE_TITLES;
};

export default HOSTNAME_PAGE_TITLES;

